var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e7fe1093f3626fc843a71a99cc4c5fb423e581b5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-nextjs@kelp-dao"]={id:"e7fe1093f3626fc843a71a99cc4c5fb423e581b5"};
      